import React, { FC } from 'react';
import { Route } from 'react-router';

import { useHeader } from '../components/common/navigation/hooks/header-service';
import DistributorsTable from '../pages/distributors-page/distributors/table';
import DistributorCreate from '../pages/distributors-page/distributors/create';
import DistributorEdit from '../pages/distributors-page/distributors/edit';

const DistributorsList: FC = () => {
  useHeader('Дистрибьюторы', []);
  return <DistributorsTable />;
};

const DistributorsPage: FC = () => {
  return (
    <>
      <Route exact path="/distributors/create" component={DistributorCreate} />
      <Route exact path="/distributors/edit/:id" component={DistributorEdit} />
      <Route exact path="/distributors" component={DistributorsList} />
    </>
  );
};

export default DistributorsPage;
